import { OktaAuth } from '@okta/okta-auth-js';
import { environment } from '../../../environments/environment';

export const oktaAuth = new OktaAuth({
  issuer: environment.oktaIssuer,
  clientId: environment.oktaClientId,
  redirectUri: window.location.origin + '/auth/login/callback',
  postLogoutRedirectUri: window.location.origin + '/auth/login',
  scopes: ['openid', 'profile', 'email'],
});
